import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const orderCardStyles = makeStyles({
  container: {
    backgroundColor: tokens.colorNeutralBackground1,
    display: "flex",
    flexDirection: "column",
    width: "100vw",
    height: "100vh",
    alignItems: "center",
  },
  main: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: tokens.colorNeutralBackground1,
    "@media (min-width: 500px)": {
      height: "100%",
      backgroundColor: tokens.colorNeutralBackground2,
      ...shorthands.padding("24px", "12px", "24px", "12px"),
    },
  },
  subMainContainer: {
    display: "flex",
    flexDirection: "column",
    "@media (min-width: 500px)": {
      flexDirection: "row",
      marginTop: "45px",
      height: "100vh",
      ...shorthands.borderRadius("8px"),
      backgroundColor: tokens.colorNeutralBackground1,
      boxShadow: tokens.shadow2,
      ...shorthands.overflow("hidden"),
      "::-webkit-scrollbar": {
        width: "4px",
        height: "4px",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        ...shorthands.borderRadius("4px"),
      },
      "::-webkit-scrollbar-track": {
        backgroundColor: "#ccc",
        ...shorthands.borderRadius("4px"),
      },
      "::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#888",
      },
      "&:hover": {
        overflowY: "auto",
      },
    },

    "@media (min-width: 500px) and (max-width: 899px)": {
      marginLeft: "40px",
      marginRight: "40px",
    },
    "@media (min-width: 900px) and (max-width: 1239px)": {
      marginLeft: "auto",
      marginRight: "auto",
      width: "840px",
    },
    "@media (min-width: 1240px) and (max-width: 1399px)": {
      marginLeft: "200px",
      marginRight: "200px",
    },
    "@media (min-width: 1400px)": {
      marginLeft: "auto",
      marginRight: "auto",
      width: "1040px",
    },
  },
  orderBody: {
    height: "100%",
    flexDirection: "column",
    width: "100vw",
    "@media (min-width: 500px)": {
      height: "inherit",
      width: "40%",
      backgroundColor: tokens.colorNeutralBackground2,
      ...shorthands.padding("28px", "28px", "12px", "12px"),
      ...shorthands.overflow("auto"),
    },
  },
  orderSummary: {
    display: "initial",
    "@media (min-width: 500px)": {
      marginTop: "-13px",
    },
  },
  divider: {
    minHeight: "4px",
  },
  totalAmount: {
    fontWeight: "bold",
    textAlign: "right",
    "@media (max-width: 499px)": {
      ...shorthands.padding("9px", "30px", "9px", "0px"),
    },
    "@media (min-width: 500px)": {
      textAlign: "right",
      ...shorthands.padding("9px", "18px", "9px", "0px"),
    },
  },
  reviewLine: {
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    paddingLeft: "16px",
    paddingTop: "10px",
    paddingBottom: "10px",
    height: "35px",
    backgroundColor: tokens.colorNeutralBackground3,
    "@media (min-width: 500px)": {
      backgroundColor: tokens.colorNeutralBackground2,
    },
  },
  itemList: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("1px"),
    backgroundColor: tokens.colorNeutralBackground1,
    "@media (min-width: 500px)": {
      backgroundColor: tokens.colorNeutralBackground2,
    },
  },

  amountBody: {
    flexDirection: "row",
    alignItems: "flex-start",
    width: "100%",
    "@media (min-width: 500px)": {
      flexDirection: "row",
      marginBottom: "8px",
    },
  },
  subTitle: {
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    paddingLeft: "16px",
    paddingTop: "10px",
    paddingBottom: "10px",
    height: "35px",
    display: "none",
    "@media (min-width: 500px)": {
      display: "block",
      fontSize: "20px",
    },
  },
  title: {
    display: "block",
    "@media (min-width: 500px)": {
      display: "none",
    },
  },
  itemAmount: {
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground3,
    alignSelf: "flex-start",
    "@media (max-width: 500px)": {
      ...shorthands.padding("0px", "10px", "0px", "0px"),
    },
  },
  taxAmount: {
    fontWeight: tokens.fontWeightRegular,
    textAlign: "right",
    "@media (max-width: 499px)": {
      ...shorthands.padding("9px", "30px", "9px", "0px"),
    },
    "@media (min-width: 500px)": {
      color: tokens.colorNeutralForeground3,
      ...shorthands.padding("9px", "18px", "9px", "0px"),
    },
  },
});
